module.exports = __webpack_public_path__ + "img/service.4175c2e5.png";